export default __webpack_public_path__ + "static/media/myclassic2.b8c61224.png";